// extracted by mini-css-extract-plugin
module.exports = {"description":"description-2rEC6","descriptionCollapsed":"descriptionCollapsed-3-8DC","button":"button-1soo5","placeholder":"placeholder-f7uzC"};